const NOTIFICATION_SOUND_URL = "/notification-sound.wav";

let audio = null;
let unlockListenerAttached = false;

const getAudio = () => {
  if (!audio) {
    audio = new Audio(NOTIFICATION_SOUND_URL);
    audio.preload = "auto";
  }
  return audio;
};

const silentUnlockSound = async () => {
  try {
    const sound = getAudio();
    sound.volume = 0;
    sound.currentTime = 0;
    await sound.play();
    sound.pause();
    sound.currentTime = 0;
    sound.volume = 1;
    return true;
  } catch (error) {
    return false;
  }
};

export const prepareNotificationSound = () => {
  silentUnlockSound();
};

export const setupNotificationSoundUnlock = () => {
  if (
    unlockListenerAttached ||
    typeof window === "undefined" ||
    Notification?.permission !== "granted"
  ) {
    return;
  }

  unlockListenerAttached = true;

  const unlock = () => {
    silentUnlockSound();
    document.removeEventListener("click", unlock, true);
    document.removeEventListener("keydown", unlock, true);
    unlockListenerAttached = false;
  };

  document.addEventListener("click", unlock, true);
  document.addEventListener("keydown", unlock, true);
};

export const playNotificationSound = async () => {
  try {
    const sound = new Audio(NOTIFICATION_SOUND_URL);
    sound.volume = 1;
    await sound.play();
  } catch (error) {
    try {
      const sound = getAudio();
      sound.currentTime = 0;
      sound.volume = 1;
      await sound.play();
    } catch (fallbackError) {
      setupNotificationSoundUnlock();
    }
  }
};

export const handleNotificationPayload = async (payload) => {
  await playNotificationSound();

  const title =
    payload?.notification?.title || payload?.data?.title || "New notification";
  const body = payload?.notification?.body || payload?.data?.body || "";

  return { title, body };
};
